import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLoginForm() {
  const navigate = useNavigate();
  const { login, logout, loading: authLoading } = useAuth();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);

  const doLogin = async (e) => {
    e.preventDefault();
    setLoggingIn(true);
    try {
      const u = await login(username, password);
      if (!u.is_admin) {
        toast.error("Esta cuenta no tiene acceso de administrador");
        logout();
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-900 flex items-center justify-center px-5">
      <div className="max-w-sm w-full">
        <div className="flex items-center gap-2 justify-center mb-6">
          <div className="w-12 h-12 rounded-2xl bg-red-600 flex items-center justify-center">
            <Shield className="w-7 h-7 text-white" strokeWidth={2.5} />
          </div>
        </div>
        <h1 className="text-3xl font-black text-white text-center mb-1 tracking-tight">
          Acceso Administrador
        </h1>
        <p className="text-sm text-zinc-400 text-center mb-8">miapoyo · Panel interno</p>

        <form onSubmit={doLogin} className="bg-zinc-800 rounded-2xl p-6 border border-zinc-700">
          <Label className="text-xs font-bold uppercase tracking-widest text-zinc-400 mb-1 block">Usuario</Label>
          <Input
            data-testid="admin-login-username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="h-12 mb-4 bg-zinc-900 border-2 border-zinc-700 text-white"
          />
          <Label className="text-xs font-bold uppercase tracking-widest text-zinc-400 mb-1 block">Contraseña</Label>
          <Input
            data-testid="admin-login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-12 mb-5 bg-zinc-900 border-2 border-zinc-700 text-white"
          />
          <Button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loggingIn || authLoading}
            className="w-full h-12 font-black bg-red-600 hover:bg-red-700 text-white rounded-xl"
          >
            {loggingIn ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
          </Button>
        </form>

        <p className="text-xs text-zinc-500 text-center mt-4">
          <button onClick={() => navigate("/")} className="underline hover:text-zinc-300">
            Volver al sitio público
          </button>
        </p>
      </div>
    </div>
  );
}
